<script setup>
import { inject } from 'vue';

// Components
import NavigationDropdown from '@/Components/Navigation/NavigationDropdown.vue';
import NavigationLink from '@/Components/Navigation/NavigationLink.vue';

const props = defineProps({
    menuItems: Object,
});

const openMobileMenu = inject('openMobileMenu');

// Components
</script>

<template>
    <div class="flex flex-col">
        <nav
            v-if="menuItems"
            :class="{ flex: openMobileMenu, hidden: !openMobileMenu }"
            class="relative z-20 flex-col items-center flex-grow gap-8 pb-4 2xl:gap-16 xl:h-auto xl:pb-0 xl:flex xl:justify-end xl:flex-row"
        >
            <li class="flex" v-for="link in menuItems" :key="link.id">
                <NavigationLink :link="link" />

                <NavigationDropdown
                    v-if="!link.data.url && link.data.sub_menu.length"
                    :title="link.data.title"
                    :childItems="link.data.sub_menu"
                />
            </li>
        </nav>
    </div>
</template>
